module.exports = __webpack_public_path__ + "img/icon_tourism_food.338e16b6.png";